/* eslint-disable no-await-in-loop */
/**
 *  create a RetryOptions.delay? function  using am exponential back off strategy
 */
export function defaultRetryDelayHandler({ initialDelay = 1000, multiplicationFactor = 2, jitter = true }) {
    return (options) => {
        const { retryCount } = options;
        const retryInMs = initialDelay * (retryCount * multiplicationFactor);
        return jitter ? retryInMs * Math.random() : retryInMs;
    };
}
/**
 *  create a RetryOptions.retry? function with defaults
 *
 */
export function defaultRetryHandler({ retryStatuses = [429, 502, 503, 504], maxRetries = 3 }) {
    return ({ response, retryCount }) => {
        if (retryCount <= maxRetries && retryStatuses.includes(response.status)) {
            return true;
        }
        return false;
    };
}
/** used to pause between retries */
export async function pause(milliseconds) {
    return new Promise(resolve => {
        setTimeout(() => resolve(), milliseconds);
    });
}
/**
 * Fetch middleware to introduce retry operations based on provided settings
 */
export function withRetries({ retry = defaultRetryHandler({}), delay = defaultRetryDelayHandler({}), onRetryEvent } = {}) {
    return async ({ url, init, fetch, response: r }) => {
        // response before this middleware is applied
        let response = r;
        // if retry, this will be the 1st one.
        let retryCount = 1;
        while (await retry({ response, retryCount })) {
            const delayAmount = await delay({ response, retryCount });
            if (onRetryEvent) {
                await onRetryEvent({ response, retryCount });
            }
            await pause(delayAmount);
            // Do not attempt any further requests if the signal was aborted while we paused
            if (init?.signal?.aborted) {
                break;
            }
            // try again with provided fetch
            try {
                response = await fetch(url, init);
            }
            catch (err) {
                if (err.name === 'AbortError') {
                    break; // end retries here and return the last response
                }
                else {
                    throw err;
                }
            }
            retryCount++;
        }
        return response;
    };
}
//# sourceMappingURL=withRetries.js.map